import React from "react";
import { useI18n } from "../providers/I18nProvider";

interface LiveAuthorizationModalProps {
  secondsLeft: number;
  totalSeconds: number;
  onAbort: () => void; // This should call abortBetChanges
}

export const LiveAuthorizationModal: React.FC<LiveAuthorizationModalProps> = ({
  secondsLeft,
  totalSeconds,
  onAbort,
}) => {
  const { t } = useI18n();

  return (
    <div className="pt-6 px-4 pb-3 flex flex-col items-center">
        <div className="text-center text-25 mb-8">
          {t("BetSlipWidgetWaitForConfirmation")}
        </div>

        {/* Countdown Circle */}
        <div className="relative w-[135px] h-[135px] mb-8" style={{ backgroundImage: "url('assets/sport/desktop-clock.svg')", backgroundSize: "contain", backgroundRepeat: "no-repeat", backgroundPosition: "center" }}>
          {/* Circle SVG */}

          {/* Timer text */}
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span className="text-50 font-bold text-primary leading-none">
              {secondsLeft > 60 ? 60 : secondsLeft}
            </span>
            <span className="text-22 font-light text-gray-800 leading-none">sec</span>
          </div>
        </div>

      {/* Cancel Button */}
      <button
        onClick={onAbort}
        className="w-full h-[45px] text-22 border border-danger text-danger rounded-4 mt-9"
      >
        {t("BetSlipWidgetCancelBet")}
      </button>
    </div>
  );
};

export default LiveAuthorizationModal;
